import { useQuery } from '@tanstack/react-query'

const CACHE_KEY = ['goneFishin']


export default function useGoneFishin(fetchHealth) {
  const {
    isPending,
    error,
    data = {},
  } = useQuery({
    queryFn: fetchHealth,
    queryKey: CACHE_KEY,
    retry: false,
  })

  return {
    error,
    isLoading: Boolean(isPending),
    isGoneFishin: Boolean(data.maintenance),
  }
}
